<template>
  <div class="mx-auto w-full bg-white relative min-h-screen">
    <div
      v-if="isPreparing"
      class="flex items-center justify-center absolute top-0 left-0 w-full h-full"
    >
      <Icon
        icon="svg-spinners:90-ring-with-bg"
        class="text-3xl text-gray-40"
      />
    </div>
    <div
      v-else
      class="min-h-screen grid grid-cols-1 grid-rows-header-main-footer"
    >
      <ChatHeader class="px-6 sticky top-0 z-10 bg-white" />
      <ChatConversation class="-mb-6" />
      <ChatFooter
        ref="footer"
        class="px-6 sticky bottom-0 z-10 bg-white"
      />
    </div>

    <Teleport to="body">
      <Transition>
        <button
          ref="scrollButtonArea"
          v-if="showScrollButton"
          :style="{ bottom: `${footerHeight}px` }"
          v-tooltip="{ content: $t('controls.scrollToBottom'), theme: 'tooltip-light' }"
          type="button"
          class="my-6 rounded-full p-2 text-white bg-dlubal-blue border-gray-60 fixed z-10 transition-opacity duration-200 ease-in-out left-1/2 -translate-x-1/2"
          @click="() => scrollToConversationBottom()"
        >
          <Icon icon="heroicons:arrow-down" />
        </button>
      </Transition>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import { useElementSize, useWindowScroll } from '@vueuse/core'
import animateScrollTo from 'animated-scroll-to'
import ChatHeader from '@/components/chat/ChatHeader.vue'
import ChatConversation from '@/components/chat/conversation/ChatConversation.vue'
import ChatFooter from '@/components/chat/ChatFooter.vue'
import { Icon } from '@iconify/vue'
import { storeToRefs } from 'pinia'
import { useConversationStore } from '@/stores/conversationStore'
import { useWindowSize } from '@vueuse/core'

const conversationStore = useConversationStore()
const { isPreparing } = storeToRefs(conversationStore)

const footerRef = useTemplateRef('footer')
const { height: footerHeight } = useElementSize(footerRef)

const scrollToConversationBottom = async () => {
  animateScrollTo([null, document.body.clientHeight], {
    elementToScroll: window,
    speed: 400
  })
}

const { y: windowY } = useWindowScroll()
const { height: bodyHeight } = useElementSize(document.body)
const { height: windowHeight } = useWindowSize()

const isOverflowing = computed(() => Math.abs(bodyHeight.value - windowHeight.value) > 50)
const isAtBottom = computed(() => Math.abs(windowY.value + windowHeight.value - bodyHeight.value) >= 50)

const showScrollButton = computed(() => {
  return !isPreparing.value && isOverflowing.value && isAtBottom.value
})
</script>
